import React from "react";
import { Box, Container } from "@mui/material";
import OnsiteHeader from "./OnsiteHeader";
import OnsiteFooter from "./OnsiteFooter";

const OnsiteReuseContainer = ({ children, maxWidth = "lg" }) => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#F8FAFC",
        backgroundImage:
          "radial-gradient(at 0% 0%, rgba(224, 231, 255, 0.45) 0px, transparent 50%), radial-gradient(at 100% 100%, rgba(238, 242, 255, 0.5) 0px, transparent 50%)",
      }}
    >
      <OnsiteHeader />
      <Container
        maxWidth={maxWidth}
        sx={{
          flexGrow: 1,
          py: { xs: 3, md: 5 },
          px: { xs: 2, sm: 3, md: 4 },
        }}
      >
        {children}
      </Container>
      <OnsiteFooter />
    </Box>
  );
};

export default OnsiteReuseContainer;
